import React from "react";

export const Field = ({ label, hint, children }) => (
  <label className="block">
    <span className="mono text-[9px] text-[#6B675F] block mb-2">{label}</span>
    {children}
    {hint && <span className="mono text-[8.5px] text-[#A8A29A] block mt-1.5">{hint}</span>}
  </label>
);

const base =
  "w-full bg-[#FAFAFA] border border-[#E2E0D8] px-3.5 py-3 text-[14px] text-[#141414] outline-none focus:border-[#C8B29B] focus:bg-white transition-colors";

export const Input = (props) => <input {...props} className={base} />;

export const Textarea = ({ rows = 4, ...props }) => (
  <textarea rows={rows} {...props} className={`${base} leading-relaxed resize-y`} />
);

export const Select = ({ children, ...props }) => (
  <select {...props} className={`${base} appearance-none`}>
    {children}
  </select>
);

export const Btn = ({ variant = "solid", children, className = "", ...props }) => {
  const styles = {
    solid: "bg-[#141414] text-[#FAFAFA] hover:bg-[#2A2A28]",
    ghost: "border border-[#E2E0D8] text-[#141414] hover:border-[#C8B29B] bg-white",
    danger: "border border-[#D9B7AE] text-[#8C2E1D] hover:bg-[#FBF1EE] bg-white",
  }[variant];
  return (
    <button
      {...props}
      className={`inline-flex items-center justify-center gap-2 px-5 py-3 mono text-[9.5px] disabled:opacity-50 transition-colors duration-300 ${styles} ${className}`}
    >
      {children}
    </button>
  );
};

export const Card = ({ children, className = "" }) => (
  <div className={`bg-white border border-[#E2E0D8] ${className}`}>{children}</div>
);

export const SectionTitle = ({ label, title, right }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
    <div>
      <p className="mono text-[9px] text-[#8C7862] mb-3">{label}</p>
      <h1 className="display text-[30px] lg:text-[38px] text-[#141414] leading-[1.05]">{title}</h1>
    </div>
    {right}
  </div>
);

export const CONTENT_LANGS = ["tr", "en", "fi", "es"];

/* Per-field language tabs. The active language lives inside this component so
   switching it never re-renders the page, closes an accordion or loses scroll. */
export const LocalizedInput = ({
  label,
  value,
  onChange,
  multiline = false,
  rows = 4,
  testid = "loc-input",
}) => {
  const [lang, setLang] = React.useState("en");
  const C = multiline ? Textarea : Input;
  const val = value || {};

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
        <span className="mono text-[9px] text-[#6B675F]">{label}</span>
        <div className="inline-flex border border-[#E2E0D8] shrink-0" data-testid={`${testid}-tabs`}>
          {CONTENT_LANGS.map((l) => {
            const filled = String(val[l] || "").trim().length > 0;
            return (
              <button
                key={l}
                type="button"
                onClick={() => setLang(l)}
                aria-pressed={lang === l}
                data-testid={`${testid}-tab-${l}`}
                className={`mono text-[8.5px] px-3 py-1.5 flex items-center gap-1.5 transition-colors duration-300 ${
                  lang === l ? "bg-[#141414] text-[#FAFAFA]" : "bg-white text-[#141414]/55 hover:text-[#141414]"
                }`}
              >
                {l.toUpperCase()}
                <span
                  className={`w-1.5 h-1.5 rounded-full ${
                    filled ? (lang === l ? "bg-[#C8B29B]" : "bg-[#8C7862]") : "bg-[#E2E0D8]"
                  }`}
                />
              </button>
            );
          })}
        </div>
      </div>
      <C
        rows={rows}
        value={val[lang] || ""}
        onChange={(e) => onChange({ ...val, [lang]: e.target.value })}
        data-testid={`${testid}-${lang}`}
      />
    </div>
  );
};
